/**
 * Resolves a runtime app URL from config: a root-relative path (e.g. `/next/`) is
 * joined with `window.location.origin`; a full `http(s)://` URL is used as-is; an
 * empty value falls back to `defaultPath` on the current origin. For local dev with
 * portal and another app on different ports, use an absolute URL in config instead.
 */
export function resolvePathOrUrl(
  configValue: string,
  defaultPath: string
): string {
  const trimmed = configValue.trim();
  if (trimmed === '') {
    return new URL(defaultPath, globalThis.location.origin).href;
  }
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return new URL(trimmed, globalThis.location.origin).href;
  }
  return new URL(trimmed).href;
}
